import { VIDEOS_ACTION_TYPES } from 'src/dashboard/state/videos/videos-actions';

import { CREATE_TEMP_VIDEO } from '../actions';

const initialState = {
  tempcode: null,
};

export default function tools(state = initialState, action) {
  switch (action.type) {
    case CREATE_TEMP_VIDEO:
      return {
        ...state,
        tempcode: action.payload,
      };

    case VIDEOS_ACTION_TYPES.deleteVideo:
      return {
        ...state,
        tempcode:
          action.payload.shortcode == state.tempcode ? null : state.tempcode,
      };

    default:
      return state;
  }
}
